import * as React from 'react';
import {CONTENT_TYPE} from '../../Config/appConfig';
import AppContainer from './AppContainer';

class ViewPolicyContainer extends React.Component <{}, {}> {
    public render() {
        return (
            <AppContainer content={CONTENT_TYPE.VIEW_POLICY}/>
        );
    }
}

export default ViewPolicyContainer;



// WEBPACK FOOTER //
// ./src/Components/Containers/ViewPolicyContainer.tsx